import { Action, createHook, createStore } from 'react-sweet-state'

import { deleteRegex, postRegex, putRegex } from '../api/regex'

export interface IRegex {
    _id: string
    name: string
    pattern: string
}

type ILookupState = {
    regexes: IRegex[]
}

const lookupInitialState: ILookupState = {
    regexes: [],
}

const lookupActions = {
    setRegexes:
        (regexes: IRegex[]): Action<ILookupState> =>
        ({ setState }) => {
            setState({ regexes })
        },
    addRegex:
        (newRegex: { name: string; pattern: string }): Action<ILookupState> =>
        async ({ setState, getState }) => {
            const { regexes } = getState()

            const _id = await postRegex(newRegex).then(
                (res) => res.data as string
            )

            setState({ regexes: [{ _id, ...newRegex }, ...regexes] })
        },
    editRegex:
        (newRegex: IRegex): Action<ILookupState> =>
        ({ setState, getState }) => {
            const regexes = structuredClone(getState().regexes)

            putRegex(newRegex)

            const regexToEditIndex = regexes.findIndex(
                (regex) => regex._id === newRegex._id
            )

            if (regexToEditIndex !== -1) {
                regexes[regexToEditIndex] = newRegex
            }

            setState({ regexes })
        },
    deleteRegex:
        (id: string): Action<ILookupState> =>
        ({ setState, getState }) => {
            const { regexes } = getState()

            deleteRegex(id)

            setState({ regexes: regexes.filter((regex) => regex._id !== id) })
        },
}

const Store = createStore({
    initialState: lookupInitialState,
    actions: lookupActions,
})

export const useLookupStore = createHook(Store)
